import React from 'react';
import { useUnitChange } from '../hooks/useUnitChange';
import { SegmentField } from './SegmentField';

export const RgbView = ({ onChange, value }) => {
  const { handleUnitChange } = useUnitChange(onChange, value);
  return (
    <>
      <SegmentField
        min={0} max={255}
        value={value.r} name="r"
        onChange={handleUnitChange}
      />
      <SegmentField
        min={0} max={255}
        value={value.g} name="g"
        onChange={handleUnitChange}
      />
      <SegmentField
        min={0} max={255}
        value={value.b} name="b"
        onChange={handleUnitChange}
      />
      <SegmentField
        key='alpha' unit='a' min={0} max={1} step={0.01}
        value={value.a} name="a"
        onChange={handleUnitChange}
      />
    </>
  );
};
